const Report = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-report"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-report"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M16.5,14h-4v-3.5c0-.827-.673-1.5-1.5-1.5h-3.5c-.827,0-1.5,.673-1.5,1.5v8c0,.827,.673,1.5,1.5,1.5h9c.827,0,1.5-.673,1.5-1.5v-3c0-.827-.673-1.5-1.5-1.5Zm-5,5H7.5c-.276,0-.5-.225-.5-.5v-3.5h4.5v4Zm0-5H7v-3.5c0-.275,.224-.5,.5-.5h3.5c.276,0,.5,.225,.5,.5v3.5Zm5.5,4.5c0,.275-.225,.5-.5,.5h-4v-4h4c.275,0,.5,.225,.5,.5v3Zm3.096-13.111l-3.484-3.484c-1.228-1.228-2.86-1.904-4.597-1.904H6.5C4.019,0,2,2.019,2,4.5v15c0,2.481,2.019,4.5,4.5,4.5h11c2.481,0,4.5-2.019,4.5-4.5V9.985c0-1.736-.677-3.369-1.904-4.597Zm-.707,.707c.551,.551,.971,1.199,1.244,1.904h-5.132c-.827,0-1.5-.673-1.5-1.5V1.368c.706,.273,1.353,.693,1.904,1.244l3.484,3.484Zm1.611,13.404c0,1.93-1.57,3.5-3.5,3.5H6.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h5.515c.334,0,.663,.03,.985,.088V6.5c0,1.379,1.121,2.5,2.5,2.5h5.412c.058,.322,.088,.651,.088,.985v9.515Z" />
    </svg>
  );
};

export default Report;
